import { render } from "./DccTab.vue?vue&type=template&id=75838e9e&scoped=true"
import script from "./DccTab.vue?vue&type=script&lang=js"
export * from "./DccTab.vue?vue&type=script&lang=js"

import "./DccTab.vue?vue&type=style&index=0&id=75838e9e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75838e9e"],['__file',"src/views/AccountReceivable/DccTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75838e9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75838e9e', __exports__)) {
    api.reload('75838e9e', __exports__)
  }
  
  module.hot.accept("./DccTab.vue?vue&type=template&id=75838e9e&scoped=true", () => {
    api.rerender('75838e9e', render)
  })

}


export default __exports__